import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CultureQuizPreview = () => {
  const sampleQuestions = [
    {
      id: 1,
      question: "What is our company\'s primary core value?",
      options: ["Innovation First", "Customer Obsession", "Team Collaboration", "Continuous Learning"]
    },
    {
      id: 2,
      question: "How often do we hold team retrospectives?",
      options: ["Weekly", "Bi-weekly", "Monthly", "Quarterly"]
    },
    {
      id: 3,
      question: "What is our approach to work-life balance?",
      options: ["Flexible hours", "Strict 9-5", "Results-oriented", "Hybrid model"]
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
            <Icon name="Brain" size={24} color="var(--color-primary)" strokeWidth={2.5} />
          </div>
          <div>
            <h3 className="text-xl font-bold text-foreground">Culture Knowledge Quiz</h3>
            <p className="text-sm text-muted-foreground">Test your understanding of our values</p>
          </div>
        </div>
        <div className="bg-muted/30 px-4 py-2 rounded-lg">
          <span className="text-sm font-semibold text-foreground">{sampleQuestions?.length} Questions</span>
        </div>
      </div>
      <div className="space-y-6">
        {sampleQuestions?.map((q, index) => (
          <div key={q?.id} className="bg-muted/20 rounded-lg p-5">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-8 h-8 bg-primary/20 rounded-full flex items-center justify-center shrink-0">
                <span className="text-sm font-bold text-primary">{index + 1}</span>
              </div>
              <p className="text-base font-medium text-foreground pt-1">{q?.question}</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 ml-11">
              {q?.options?.map((option, optIndex) => (
                <div 
                  key={optIndex}
                  className="bg-card border border-border rounded-lg px-4 py-3 text-sm text-muted-foreground hover:border-primary/50 hover:bg-primary/5 transition-all duration-200 cursor-not-allowed opacity-60"
                >
                  {option}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Lock" size={16} color="var(--color-muted-foreground)" />
          <span>Available in full release</span>
        </div>
        <Button variant="outline" disabled>
          Start Quiz
        </Button>
      </div>
    </div>
  );
};

export default CultureQuizPreview;